/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingAggregationTrendResult {
    getFixupPrototypeFunction() { return BillingAggregationTrendResult.fixupPrototype; }

    static newInstance(model: Partial<BillingAggregationTrendResult>): BillingAggregationTrendResult {
        let obj = Object.assign(new BillingAggregationTrendResult(), model);
        BillingAggregationTrendResult.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingAggregationTrendResult>): BillingAggregationTrendResult {
        if (!model) return null;
        return BillingAggregationTrendResult.newInstance(<BillingAggregationTrendResult> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingAggregationTrendResult) {
        if (!obj) return;

        models.BillingAggregationTrendResult.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingAggregationTrendResult): boolean {
        Object.setPrototypeOf(obj, BillingAggregationTrendResult.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.identity) {
            models.BillingLineItemIdentityPlus.fixupPrototype(this.identity);
        }
        if (this.timestamps) {
            for (let i = 0; i < this.timestamps.length; i++) {
                let val = this.timestamps[i];
                if (typeof val === "string") {
                    this.timestamps[i] = new Date(<string><any>val);
                }
            }
        }
    }

    /**
     * Identity of the result group
     */
    identity: models.BillingLineItemIdentityPlus;

    timestamps: Array<Date>;

    values: Array<number>;

}
